<template>
    <v-footer
        indigo
        padless
        class="mt-8"
    >
        <v-card :style="background" style="width: 100%;">
            <div class="text-center content-footer my-md-16 px-md-16 py-10">
                <h1 class="font-weight-bold mb-4 font-italic white--text font-title">
                    <i>¡Suscríbase para recibir nuestras promociones y novedades!</i>
                    <v-text-field
                        class='input-newsletter'
                        label="Escriba su email aquí"
                        outlined
                        dense
                        style="border-radius:30px"
                        append-icon="mdi-send"
                    ></v-text-field>
                </h1>
            </div>
            <div class="pt-16 content-footer my-16">
                <v-row class="white--text">
                    <v-col cols="12" md="4" class="text-center">
                        <v-col cols='12' class='logo-footer'>
                            <v-img :src="`${require('@/assets/logo-blanco-innofarm.png')}`"/>
                        </v-col>
                        <v-col cols='12'>
                            <img class='mx-3' :src="`${require('@/assets/fb-blanco-footer.png')}`" width="35px">
                            <img class='mx-3' :src="`${require('@/assets/ig-blanco-header.png')}`" width="35px">
                            <img class='mx-3' :src="`${require('@/assets/tw-blanco-footer.png')}`" width="35px">
                           
                        </v-col>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-row class='ml-md-16 font-title'>
                            <v-col cols="6"  >
                                <div class='text-md-left mb-5 ' ><b>INFORMACIÓN</b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/nosotros'>Nosotros</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/sedes'>Sedes</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/contactos'>Contáctenos</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/covid19'>Covid-19</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/trabaja-con-nosotros'>Empleos</a></b></div>
                            </v-col>
                            <v-col cols="6"  >
                                <div class='text-md-left mb-5'><b>SERVICIOS</b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/medicamentos-especialidad'>Medicamentos de especialidad</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/aplicaciones'>Aplicaciones</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/analisis-laboratorio'>Laboratorio</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/estudios-medicos'>Estudios médicos</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/enfermeria'>Enfermería</a></b></div>
                                <div class='text-md-left'><b><a class='white--text font-weight-regular text-h6' href='/empresas_pymes'>Corporativo</a></b></div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-row class='ml-md-16'>
                            <v-col cols="12" >
                                <div class='text-md-left mb-5'><b>TELÉFONOS DE CONTACTO</b></div>
                                <div class='text-md-left font-title'>
                                    <h2>
                                        <a href='tel:02510070' class='text-decoration-none white--text'>
                                            <v-btn 
                                                icon 
                                                elevation="2" 
                                                style="background:white"
                                            >
                                                <v-icon color="#62c091">mdi-24px  mdi-phone</v-icon>
                                            </v-btn>
                                            (02) 5100700
                                        </a>
                                    </h2>
                                </div>
                                <div class='text-md-left mt-4 font-title'>
                                    <h2>
                                        <a class='text-decoration-none white--text' target='_blank' href='https://api.whatsapp.com/send?phone=+593991342224'>
                                            <v-btn 
                                                icon 
                                                elevation="2" 
                                                style="background:white"
                                            >
                                                <v-icon color="#62c091">mdi-24px  mdi-whatsapp</v-icon>
                                            </v-btn>
                                            099 134 2224
                                        </a>
                                    </h2>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div class="text-center footer-bootom white--text font-title">
                <strong >Innofarm © {{ new Date().getFullYear() }} Todos los derechos reservados</strong>
            </div>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    name: 'FooterComponent',
    data:()=>({
        img : require('@/assets/fondo-footer.png')
    }),
    computed: {
        background() {
            return {
                'background-image': `url(${this.img})`,
                'background-size': 'cover'
            }
        }
    }

}
</script>

<style scoped>
    .footer-bootom{
        background: #f8a747;
        padding: 10px 0px;
    }

    .content-footer{
        margin-right: 64px!important;
        margin-left: 64px!important;
        text-align: center;
    }
   
    .input-newsletter{
        width: 70%;
        margin:0 auto;
        color:white!important;
        background: white!important;
        height: 39px;
    }

    .logo-footer{
        width: 70%;
        margin: 0 auto;
    }
    
    a{
        text-decoration: none;
        
    }

    .v-application .text-h6{
        font-family: Asap!important
    }

    @media(max-width:1000px){
        .input-newsletter{
            width: 100%;
            margin:0 auto
        }
        .content-footer{
            margin-right: 30px!important;
            margin-left: 30px!important;
        }
    }
</style>